<template>
  <v-card class="kim-card">

    <positive-banner v-if="!loading && positivePhrase" :phrase="positivePhrase" />

    <v-card-text class="pt-0">

      <v-layout v-if="loading" justify-center align-center>
        <v-flex xs12 text-center pt-4 mt-4>
          <div class="title font-weight-light">Cargando...</div>
          <v-progress-linear color="primary" size="80" height="1" indeterminate></v-progress-linear>
        </v-flex>
      </v-layout>

      <v-scroll-y-transition>
        <v-layout v-show="!loading" justify-center wrap>

          <template v-if="currentProvider">

            <v-flex xs12 px-2>

              <v-layout wrap>
                <v-flex xs12>
                  <provider-stats :provider="currentProvider"/>
                </v-flex>
                <v-flex xs12 md4 pa-1>
                  <appointments-counter v-if="!loading" :total="events.total" />
                </v-flex>
                <v-flex xs12 md8 pa-1>
                  <v-card flat height="280">
                    <v-card-text>
                      <line-chart
                          class="chart"
                          v-if="chartData"
                          :chart-data="chartData"
                          :options="chartOptions"
                          :styles="chartStyles"
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>

            </v-flex>

            <v-flex xs12 pa-3>
              <v-layout wrap align-center>

                <v-flex xs8 >
                  <div class="subheading">Para hoy</div>
                </v-flex>
                <v-flex xs4 text-right mb-2>
                  <v-btn small dark :fab="$vuetify.breakpoint.smAndDown"  color="primary"  :to="{name: 'panel.provider.specialist_daily_schedule'}">
                    <v-icon size="14" :class="[{'mr-2': $vuetify.breakpoint.mdAndUp}]">fas fa-door-open</v-icon>
                    <template v-if="$vuetify.breakpoint.mdAndUp">
                      Ir a atención
                    </template>
                  </v-btn>
                </v-flex>
                <v-flex xs12 mt-0 mb-2>
                  <v-divider ></v-divider>
                </v-flex>

                <v-flex xs12 md4 lg3 xl2 pa-1>

                  <v-card flat >
                    <v-card-text>
                      <v-layout wrap>
                        <v-flex xs4 text-center>
                          <v-avatar size="50" color="success">
                            <v-icon size="20" color="white">
                              fas fa-user-clock
                            </v-icon>
                          </v-avatar>
                        </v-flex>
                        <v-flex xs8 pa-1>
                          <v-layout wrap align-center justify-center>
                            <v-flex xs12 text-center>
                              <span class="title">{{events.todayEvents.length}}</span>
                            </v-flex>
                            <v-flex xs12 text-center>
                              {{clientPlural}} citados
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                </v-flex>

                <v-divider vertical/>

                <v-flex xs12 md4 lg3 xl2 pa-1>

                  <v-card flat>
                    <v-card-text>
                      <v-layout wrap>
                        <v-flex xs4 text-center>
                          <v-avatar size="50" color="warning">
                            <v-icon size="20" color="white">
                              fas fa-hourglass-half
                            </v-icon>
                          </v-avatar>
                        </v-flex>
                        <v-flex xs8 pa-1>
                          <v-layout wrap align-center justify-center>
                            <v-flex xs12 text-center>
                              <span class="title">{{events.todayWaitingEvents.length}}</span>
                            </v-flex>
                            <v-flex xs12 text-center>
                              {{clientPlural}} en espera
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>

                </v-flex>

              </v-layout>
            </v-flex>
          </template>

        </v-layout>
      </v-scroll-y-transition>

    </v-card-text>
  </v-card>
</template>

<script>

import ProviderStats from "@/components/providers/ProviderStats";
import {ApiUtils} from "@/utils/ApiUtils";
import {mapState} from "vuex";
import LineChart from './LineChart'
import PositiveBanner from "@/components/dashboard/PositiveBanner";
import AppointmentsCounter from "@/components/dashboard/AppointmentsCounter";

export default {

  components: {
    AppointmentsCounter,
    PositiveBanner,
    ProviderStats,
    LineChart
  },

  data() {
    return {
      loading: false,
      error: false,
      stats: null,
      positivePhrase: null,
      events: {
        todayEvents: [],
        todayWaitingEvents: [],
        total: 0
      },
      chartData: null,
      chartStyles: {
        height: '250px'
      },
      chartOptions: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              }
            }]
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },

  created() {
    this.getStats()
  },

  methods: {

    async getStats() {

      var vm = this
      if (vm.loading || !vm.currentProvider) return

      vm.loading = true
      const response = await ApiUtils.makeGet(`specialist/stats/${vm.currentProvider.id}`)

      setTimeout(function () {
        vm.loading = false
      }, 1000)

      if (!response.ok) {
        vm.error = true
        return
      }

      const json = await response.json()
      const {stats, events, positive_phrase} = json.result
      vm.chartData = {
        labels: stats.labels,
        datasets: [
          {
            label: 'Atendidas',
            backgroundColor: 'rgba(74,202,65,0.6)',
            borderColor: 'rgba(74,202,65,0.6)',
            data: stats.datasets.attended,
            lineTension: 0,
            borderWidth: 3
          }, {
            label: 'Canceladas',
            backgroundColor: 'rgb(219,72,123)',
            borderColor: 'rgb(219,72,123)',
            data: stats.datasets.cancelled,
            lineTension: 0,
            borderWidth: 3
          }
        ]
      }

      vm.positivePhrase = positive_phrase

      vm.events.todayEvents = events.today_events
      vm.events.todayWaitingEvents = events.today_waiting_events
      vm.events.total = events.total_events

    }
  },
  computed: {
    ...mapState(['currentUser', 'currentProvider']),
    isUserDataUncompleted() {
      var vm = this
      return !vm.currentUser ||
          !vm.currentUser.first_name ||
          !vm.currentUser.last_name ||
          !vm.currentUser.email ||
          !vm.currentUser.dni ||
          vm.currentUser.insurance_company === null ||
          !vm.currentUser.phone1
    }
  },
  watch:{
    currentProvider(){
      const vm = this
      vm.getStats()
    }
  }
}
</script>

<style scoped>
.chart {
  color: #fff !important;
}
</style>
